import { X, Sparkles } from 'lucide-react';

interface WelcomeBannerProps {
  onDismiss: () => void;
  onExitPreview: () => void;
  showCategoryNav?: boolean;
}

export function WelcomeBanner({ onDismiss, onExitPreview, showCategoryNav = true }: WelcomeBannerProps) {
  return (
    <div
      className={`bg-gradient-to-r from-blue-600 to-blue-700 text-white shadow-lg flex-shrink-0 ${showCategoryNav ? 'md:ml-56' : ''}`}
      role="banner"
      aria-label="Welcome to New Shop preview"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex items-start justify-between gap-4">
          <div className="flex items-start gap-3 flex-1">
            <div className="flex-shrink-0 mt-0.5">
              <Sparkles className="w-6 h-6" aria-hidden="true" />
            </div>
            <div className="flex-1 min-w-0">
              <h2 className="text-lg font-semibold mb-1">
                You're previewing the new shop design
              </h2>
              <p className="text-sm text-blue-100 mb-3">
                We're testing an improved experience. Share your feedback to help us improve.
              </p>
              <div className="flex flex-wrap gap-3">
                <button
                  onClick={onExitPreview}
                  className="text-sm font-medium text-white underline hover:no-underline focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-blue-600 rounded"
                >
                  Return to Classic View
                </button>
              </div>
            </div>
          </div>
          <button
            onClick={onDismiss}
            className="flex-shrink-0 p-1 rounded-md hover:bg-blue-800 transition-colors focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-blue-600"
            aria-label="Dismiss welcome banner"
          >
            <X className="w-5 h-5" aria-hidden="true" />
          </button>
        </div>
      </div>
    </div>
  );
}
